import { render } from "./shortCodePricing.vue?vue&type=template&id=9c6f2e94"
import script from "./shortCodePricing.vue?vue&type=script&lang=js"
export * from "./shortCodePricing.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__